import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';

import avatar from '../../theme/assets/other/lp_cabinet_avatar.png';
import leagueIcon from '../../theme/assets/svg/lp_cabinet_league_icon.svg';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import qIcon from '../../theme/assets/svg/lp_q_icon.svg';

const LaunchpadLeague = (props) => {
    const {currentValueId} = props;

    const { t } = useTranslation();

    const data = [
        {name: 'omt', value: 0, id: 1},
        {name: 'index', value: 10, id: 2},
    ]

    const launchpadStatuses = useSelector(store => store.cabinet.launchpadStatuses);
    const userData = useSelector(store => store.cabinet.userData);

    const currentItem = data.find(item => item.id === currentValueId);

    const [activeStatus, setActiveStatus] = useState(null);

    const valueHandler = (value) =>{
        if (value < 0){
            return '0'
        } else {
            return value;
        }
    }


    useEffect(() => {
        if (launchpadStatuses?.next_status){
            setActiveStatus(launchpadStatuses?.next_status)
        }
    }, [launchpadStatuses]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.userWrap}`}>
                    <div className={`${Styles.userBox}`}>
                        <div className={`${Styles.imgWrap}`}>
                            <img src={userData?.user?.avatar_url || avatar} alt={userData?.user?.name}/>
                        </div>
                        <div className={`${Styles.userName}`}>{userData?.user?.name}</div>
                    </div>
                    {userData?.user?.status_id ? null :
                        <div className={`${Styles.userNoteWrap}`}>
                            <div className={`${Styles.userNoteTitle}`}>{t('Не имеет права на участие')}</div>
                            <div className={`${Styles.userNoteText}`}>
                                {t('Недостаточное количество замороженных')} {currentItem.name === 'omt' ? "OMT" : "INDEX"} {t('для участия в IDO и приватной продаже. Рекомендуем увеличить сумму заморозки')}.
                            </div>
                        </div>
                    }
                </div>
                <div className={`${Styles.leagueWrap}`}>
                    <div className={`${Styles.leagueTitleRow}`}>
                        <div className={`${Styles.leagueTitleRowName}`}>
                            <div className={`${Styles.leagueTitleRowNameImgWrap}`}>
                                <img src={leagueIcon} alt="OMT POWER"/>
                            </div>
                            <div className={`${Styles.leagueTitleRowNameText}`}>
                                {currentItem.name === 'omt' ? t('Ценность OMT') : t('Ценность INDEX')}
                                <div className={`${Styles.leagueTitleRowNameAbsWrap}`}>
                                    <div className={`${Styles.qIcon}`}>
                                        <img src={qIcon} alt="q ic"/>
                                        <div className={`${Styles.textWrap}`}>
                                            <div className={`${Styles.textWrapTitle}`}>{t('Для перехода не следующий уровень вам не хватает:')}</div>
                                            <div className={`${Styles.valueRow}`}>
                                                <div className={`${Styles.valueRowItem}`}>{activeStatus ? valueHandler(activeStatus?.academy_lessons_completed - userData?.user?.honee_lessons_completed) : '0'} {t('урока')}</div>
                                                <div className={`${Styles.valueRowItem}`}>{activeStatus ? valueHandler(activeStatus?.academy_lessons_points - userData?.user?.honee_lessons_points) : '0'} {t('баллов в OMT Academy')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${Styles.leagueTitleRowValue}`}>{t('Шанс получения алокации')}</div>
                    </div>
                    <div className={`${Styles.leagueBox}`}>
                        {launchpadStatuses?.statuses?.length > 0 ? launchpadStatuses?.statuses?.map((item, index)=>{
                            return (
                                <div className={`${Styles.leagueBoxItem} ${userData?.user?.status_id === item?.id ? Styles.leagueBoxItemActive : null}`} key={'leagueBoxItem' + index}>
                                    <div className={`${Styles.leagueBoxItemName}`}>
                                        <div className={`${Styles.leagueBoxItemNameText}`}>{currentItem.name} {item.name}</div>
                                        <div className={`${Styles.leagueBoxItemNameValue}`}>{currentItem.name === 'omt' ? item.omt_amount * 1 : item.index_amount * 1}+</div>
                                    </div>
                                    <div className={`${Styles.leagueBoxItemValue} ${item.probability_percentage * 1 === 100 ? Styles.leagueBoxItemValueG : null}`}>{item.probability_percentage * 1 === 100 ? t('Гарантировано') : `${item.probability_percentage * 1}%`}</div>
                                </div>
                            )
                        }) : null}
                    </div>
                    <div className={`${Styles.leagueNote}`}>
                        {t('Вероятности — это средние значения, рассчитанные на основе последних IDO. Шансы не гарантированы.')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LaunchpadLeague;